module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../../node_modules/happypack/loader.js?id=jsx!./GroupBuyShareView.js"));
	}, "GroupBuyShareView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=GroupBuyShareView!./src/pages/Shop/Member/TradeManage/OrderList/GroupBuy/GroupBuyShare/GroupBuyShareView.js
// module id = 1527
// module chunks = 418